import React from "react";

/**
 * 取得履歴テーブルの「対象なし」セル表示。
 * 種別なし（DownloadCell）・登記取得日なし（PictureReceivedDateCell）の双方で使う共通マーク。
 * 「—」を視覚装飾だけで表さず、対象なしであることをスクリーンリーダーで読み上げ可能にする。
 */
export const EmptyCellMark: React.FC = () => (
  <span role="img" aria-label="対象なし">
    —
  </span>
);
